import { getResponse } from 'helpers/api'

import { SchoolService as ISchoolService, SchoolApiRoutes } from './types'

const SchoolService: ISchoolService = {
	checkInviteCode(body) {
		const apiUrl = SchoolApiRoutes.CHECK_INVITE_CODE
		return getResponse(apiUrl, body)
	},
	inviteUser(body) {
		const apiUrl = SchoolApiRoutes.INVITE_USER

		return getResponse(apiUrl, body)
	}
}

export default SchoolService
